const hostname = window.location.hostname;

export const PAPER_BASE =
  hostname === 'pinkpaper.kr' ||
  hostname === 'www.pinkpaper.kr'
    ? ''
    : '/paper';

export const isPaperDomain =
  hostname === 'pinkpaper.kr' || hostname === 'www.pinkpaper.kr';
